import React from "react";
import { Box } from "@mui/material";
import "../Banner.css";

const Banner = ({ height = "500px", title = "", subtitle = "", image = null }) => {
  return (
<Box
  sx={{
    width: "100%",
    marginTop: "80px",
    position: "relative",
    overflow: "hidden",
    borderRadius: "20px",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
  }}
>
  <img
    src={image}
    alt="Banner"
    style={{
      width: "100%",
      height: "auto",
      display: "block",
    }}
  />
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      color: "white",
      padding: "20px",
    }}
  >
    <h1 className="banner-title">{title}</h1>
    <p className="banner-subtitle">{subtitle}</p>
  </Box>
</Box>

  );
};

export default Banner;
